<div class="ui-accounts-biometric-add">
  <h3 class="ui-accounts-biometric-add-title ui-title" mat-dialog-title>Añadir ingreso rápido</h3>
  
  <div class="ui-accounts-biometric-add-content" mat-dialog-content>
    <p>¿Queres añadir el inicio de sesión rápido mediante tus datos biométricos?</p>
    <mat-checkbox color="primary" [(ngModel)]="dontAsk">No volver a preguntar</mat-checkbox>
  </div>
    
  <div class="ui-accounts-biometric-add-actions" mat-dialog-actions>
    <button class="ui-button" mat-button (click)="onCancel()">No</button>
    <button class="ui-button" mat-button (click)="onAdd()" color="primary">Si, Añadir</button>
  </div>
</div>